/*
 * @Author: wzc
 * @Date: 2024-05-08 10:42:36
 * @LastEditors: wzc
 * @LastEditTime: 2024-05-15 19:11:02
 * vue2.0 拖拽事件：开启触发拖拽事件的长按需要 touch 事件，但是启动拖拽之后需要监听 drag 相关事件
 * 当有人删除某个主题时，而恰好另一个人在拖拽排序，则只有后端将最新的数据按照最后的排序存到数据库中（后端处理）
 */
export default {
  props: {},
  data() {
    return {
      draggableGroupRefsName: '', // 拖拽最外层dom 的refs name
      draggableGroupDom: null, // 通过refs 获取到的 dom 对象
      draggableStatus: null, // 拖拽的状态： ['draggable_open(开启拖拽)']
      touchStartTime: 0, // 按下的时间
      setTimerId: null, // 存储是否长按事件的 timerId
      LONG_PRESS_TIME: 1000, // 设置长按时间（单位：毫秒）
      dragTarget_curId: null, // 要被拖拽目的id
      dragoverEvent_curId: null, // 拖拽移动时选中的id
      dropEvent_curId: null, // 拖拽完成时选中的id
    }
  },
  created() {
    console.debug(`init draggable`)
  },
  mounted() {
    this.scrollContainer = document.getElementById('containerFull_body')
    if (this.draggableGroupRefsName) {
      this.draggableGroupDom = this.$refs[this.draggableGroupRefsName]
      console.debug('draggable:', this.draggableGroupDom)
      this.initDraggableTriggerEvent(this.draggableGroupDom)
    }
  },
  beforeDestroy() {
    console.debug('注销监听事件')
    this.draggableGroupDom.removeEventListener(
      touchEventArr[0],
      this.touchStartAddEventFun
    )
    this.draggableGroupDom.removeEventListener(
      touchEventArr[1],
      this.touchMoveAddEventFun
    )
    this.draggableGroupDom.removeEventListener(
      touchEventArr[2],
      this.touchUpAddEventFun
    )
    this.draggableGroupDom.removeEventListener('click', this.clickAddEventFun)

    this.draggableGroupDom.removeEventListener(
      'dragstart',
      this.dragstartAddEventFun
    )
    // 第二步：添加dragover事件 (这个事件是必须添加的，不添加这个dragover事件，drop事件触发不了)
    this.draggableGroupDom.removeEventListener(
      'dragover',
      this.dragoverAddEventFun
    )

    // 第三步：添加drop拖拽完成事件 (主要是监听完成拖拽的事件)
    this.draggableGroupDom.removeEventListener('drop', this.drogAddEventFun)
    this.draggableGroupDom.removeEventListener(
      'dragend',
      this.dragendAddEventFun
    )

    // 为document添加滚动事件
    document.removeEventListener('wheel', this.scrollBarWheelAddEventFun)
  },
  watch: {
    // isRefresh(newVal, oldVal) {
    //   console.debug(`isRefresh status: ${newVal}, ${oldVal}`)
    //   if (newVal && !oldVal) {
    //     this.refreshCallbackHandle(this.refreshCallback)
    //   } else if (!newVal && oldVal) {
    //     this.cancelRefreshCallBackHandle()
    //   }
    // },
  },
  methods: {
    initDraggableTriggerEvent(dom) {
      // 初始化拖拽触发监听事件，监听是否要开启拖拽事件
      if (!dom) return
      this.triggerAreaHeight_top = 94 + 50 // 单位px
      this.triggerAreaHeight_bottom = 100 // 单位px
      this.draggableEveryDisplace = 1 //单位px
      // 设置长按的最小时间，单位毫秒
      this.LONG_PRESS_TIME = 1000
      // 要绑定长按事件的元素
      this.setTimerId = null
      this.touchStartTime = 0
      let touchEventArr = []
      //   判断是否支持 touch 事件
      if ('ontouchstart' in window || navigator.maxTouchPoints) {
        // 移动设备上的代码
        touchEventArr = ['touchstart', 'touchmove', 'touchend']
      } else {
        // PC 上的代码
        touchEventArr = ['mousedown', 'mousemove', 'mouseup']
      }
      console.debug('initDraggableTriggerEvent', dom.offsetWidth)
      dom.addEventListener(touchEventArr[0], this.touchStartAddEventFun)
      dom.addEventListener(touchEventArr[1], this.touchMoveAddEventFun)
      dom.addEventListener(touchEventArr[2], this.touchUpAddEventFun)
      dom.addEventListener('click', this.clickAddEventFun)
    },
    draggableEvent_cancel_setTimerEvent(state, event) {
      console.debug('setTimerEvent')
      if (this.setTimerId) {
        // 在 touchstart 中没有开启拖拽事件， setTimerId 才会有值
        clearTimeout(this.setTimerId)
        this.setTimerId = null
      }
      if (state === 'move') {
        // 只有在移动时才会考虑是否开启拖拽事件；松开时一定是取消定时事件，无论是否开启拖拽都要结束拖拽事件
        // let touchMoveTime = new Date().getTime()
        // let timeDiff = touchMoveTime - this.touchStartTime
        // if (timeDiff > this.LONG_PRESS_TIME) {
        //   // 执行长按后的操作
        //   console.debug('长按事件触发了！')
        //   this.draggableEvent_start(event)
        // }

        // touch中的移动不会触发开启拖拽事件
        this.touchStartTime = 0
        this.themeList_draggable.forEach((draggableItem) => {
          draggableItem.isDraggable = false
          draggableItem.isDraggableOver = false
        })
      } else if (state === 'up') {
        this.touchStartTime = 0
        this.themeList_draggable.forEach((draggableItem) => {
          draggableItem.isDraggable = false
          draggableItem.isDraggableOver = false
        })
      }
      setTimeout(() => {
        this.draggableStatus = null
      }, 50)
    },
    draggableEvent_start(event) {
      // 拖拽事件开启
      this.setTimerId = null
      this.touchStartTime = 0

      // 获取触发事件的元素
      let touchTarget = event.target

      // 使用closest方法查找最近的匹配的父级元素
      let parentElement = touchTarget.closest('.themeContain')
      if (parentElement) {
        // 如果找到了匹配的父级元素，可以在这里执行相关操作
        console.debug('找到了父级元素:', parentElement)
        this.dragTarget_curId = parentElement.getAttribute('draggable_id')
        this.draggableStatus = 'draggable_open'
        this.themeList_draggable.forEach((draggableItem) => {
          if (draggableItem.dataItemId === this.dragTarget_curId) {
            draggableItem.isDraggable = true
            this.dragTarget_curItem = draggableItem
          } else {
            draggableItem.isDraggable = false
          }
        })
        this.startUp_draggableEvent(this.draggableGroupDom)
      } else {
        // 没有找到父级元素说明，长按事件不是在主题dom触发的
        console.debug('没有找到匹配的父级元素')
      }
    },
    // draggableEvent_move(event, move) {
    //   // 开启拖拽事件后，移动时触发的事件
    //   console.debug('移动时父级元素:', move)
    // },
    startUp_draggableEvent(dom) {
      // 启动拖拽事件
      //第一步：添加dragstart事件 (这里是拖拽前触发的时间，不要使用preventDefault阻止默认时间)
      dom.addEventListener('dragstart', this.dragstartAddEventFun)
      // 第二步：添加dragover事件 (这个事件是必须添加的，不添加这个dragover事件，drop事件触发不了)
      dom.addEventListener('dragover', this.dragoverAddEventFun)

      // 第三步：添加drop拖拽完成事件 (主要是监听完成拖拽的事件)
      dom.addEventListener('drop', this.drogAddEventFun)
      dom.addEventListener('dragend', this.dragendAddEventFun)

      // 为document添加滚动事件
      document.addEventListener('wheel', this.scrollBarWheelAddEventFun)
    },
    clickAddEventFun(event) {
      if (this.draggableStatus) {
        // 阻止 click 事件的默认行为
        event.preventDefault()
        console.debug('阻止 click 事件的默认行为')
        // 执行特殊的快速点击行为
        // ...
        // isMouseDown = false;
      } else {
        // 执行常规的点击行为
        // ...
      }
    },
    touchStartAddEventFun(event) {
      // 记录触摸开始的时间
      console.debug('touchStart', event)
      this.touchStartTime = new Date().getTime()
      this.setTimerId = setTimeout(() => {
        console.debug('长按事件触发了！')
        this.draggableEvent_start(event)
      }, this.LONG_PRESS_TIME)
    },
    touchMoveAddEventFun(event) {
      // 按住移动了
      if (this.touchStartTime === 0) return
      this.draggableEvent_cancel_setTimerEvent('move', event)
      // this.draggableEvent_move(event, touchEventArr[1])
    },
    touchUpAddEventFun(event) {
      console.debug('touchUp', event)
      // 点击结束时不需要长按事件
      this.draggableEvent_cancel_setTimerEvent('up')
    },
    dragstartAddEventFun(event) {
      console.debug('dragstart', event)
      event.dataTransfer.setData('drag_theme', event.target.innerHTML) //1.设置拖拽元素的DOM
    },
    dragoverAddEventFun(event) {
      console.debug('触发 dragover:', event)
      event.preventDefault() // ****************************必须声明的事件*****************************

      const clientY = event.clientY // 鼠标的clientY位置
      const containerTop = this.scrollContainer.scrollTop // 滚动区域顶部的clientY位置
      const containerBottom = this.scrollContainer.scrollHeight // 滚动区域实际内容高度
      const clientHeight = window.innerHeight

      if (clientY < this.triggerAreaHeight_top && containerTop > 0) {
        // 说明可拖拽的区域顶部有一部分区域已经被隐藏了，移动上面区域需要触发向上滚动
        // 鼠标在特定区域触发
        this.scrollContainer.scrollBy(0, this.draggableEveryDisplace * -1) // 向上滚动
      } else if (
        containerBottom - clientHeight > 0 &&
        clientY > clientHeight - this.triggerAreaHeight_bottom
      ) {
        // 说明还可以往下滚动
        // 鼠标在屏幕特定区域以下都触发往下滚动
        this.scrollContainer.scrollBy(0, this.draggableEveryDisplace) // 向上滚动
      }

      // console.debug(
      //   'containerTop:',
      //   containerTop,
      //   clientY,
      //   event,
      //   this.scrollContainer.scrollTop,
      //   containerBottom
      // )

      let touchTarget = event.target
      let parentElement = touchTarget.closest('.themeContain')
      if (parentElement) {
        // 移动时选中的dom
        let dragoverEvent_curId = parentElement.getAttribute('draggable_id')
        if (dragoverEvent_curId !== this.dragoverEvent_curId) {
          // 更换了新的拖拽位置才需要往下面
          console.debug('dragover', event, parentElement)
          this.dragoverEvent_curId = dragoverEvent_curId
          this.dragoverEvent_curIndex =
            parentElement.getAttribute('draggable_index')
          console.debug(this.dragoverEvent_curId)
          if (this.dragoverEvent_curId !== this.dragTarget_curId) {
            // 选中id与移动id不一致时，要改变数组顺序
            this.themeList_draggable.forEach((draggableItem, index) => {
              if (draggableItem.dataItemId === this.dragTarget_curId) {
                this.dragTarget_curIndex = index
              }
            })

            let direction = null
            if (this.dragoverEvent_curIndex < this.dragTarget_curIndex) {
              direction = 'up'
            } else if (this.dragoverEvent_curIndex > this.dragTarget_curIndex) {
              direction = 'down'
            }
            console.debug('direction:', direction)

            let themeList_draggable = []
            // let isInsetFlag = false
            if (direction) {
              this.themeList_draggable.forEach((draggableItem) => {
                if (
                  draggableItem.dataItemId !== this.dragTarget_curId &&
                  draggableItem.dataItemId !== this.dragoverEvent_curId
                ) {
                  themeList_draggable.push(draggableItem)
                } else if (
                  draggableItem.dataItemId === this.dragoverEvent_curId
                ) {
                  if (direction === 'up') {
                    // 向上时，将拖拽目标插在前面
                    themeList_draggable.push(this.dragTarget_curItem)
                    themeList_draggable.push(draggableItem)
                  } else if (direction === 'down') {
                    // 向下时，将拖拽目标插在当前的后面
                    themeList_draggable.push(draggableItem)
                    themeList_draggable.push(this.dragTarget_curItem)
                  }
                }
              })
              this.themeList_draggable = themeList_draggable
            }

            //   this.themeList_draggable.forEach((draggableItem) => {
            //     if (draggableItem.dataItemId === this.dragoverEvent_curId) {
            //       draggableItem.isDraggableOver = true
            //     } else {
            //       draggableItem.isDraggableOver = false
            //     }
            //   })
          }
        } else {
          console.debug('parentElement没有变化')
        }
      } else {
        console.debug('没有找到parentElement')
        this.themeList_draggable.forEach((draggableItem) => {
          draggableItem.isDraggableOver = false
        })
      }
    },
    drogAddEventFun(event) {
      console.debug('drop', event)
      event.preventDefault()
    },
    dragendAddEventFun(event) {
      console.debug('dragend', event)
      event.preventDefault()

      // let direction = null
      // if (this.dragoverEvent_curIndex < this.dragTarget_curIndex) {
      //   direction = 'up'
      // } else if (this.dragoverEvent_curIndex > this.dragTarget_curIndex) {
      //   direction = 'down'
      // }
      // console.debug('direction:', direction)
      // let themeList_draggable = []
      // // let isInsetFlag = false
      // if (direction) {
      //   this.themeList_draggable.forEach((draggableItem) => {
      //     if (
      //       draggableItem.dataItemId !== this.dragTarget_curId &&
      //       draggableItem.dataItemId !== this.dragoverEvent_curId
      //     ) {
      //       themeList_draggable.push(draggableItem)
      //     } else if (draggableItem.dataItemId === this.dragoverEvent_curId) {
      //       if (direction === 'up') {
      //         // 向上时，将拖拽目标插在前面
      //         themeList_draggable.push(this.dragTarget_curItem)
      //         themeList_draggable.push(draggableItem)
      //       } else if (direction === 'down') {
      //         // 向下时，将拖拽目标插在当前的后面
      //         themeList_draggable.push(draggableItem)
      //         themeList_draggable.push(this.dragTarget_curItem)
      //       }
      //     }
      //   })
      //   this.themeList_draggable = themeList_draggable
      // }

      this.draggableEvent_cancel_setTimerEvent('up')
    },
    scrollBarWheelAddEventFun(event) {
      // 如果当前正在拖拽，阻止滚动事件
      if (this.draggableStatus) {
        event.preventDefault()
      }
      // 你可以在这里添加其他的滚动处理逻辑
    },
  },
}
